import React, { useContext, useEffect, useState } from "react";
import { Modal, Input, Row, Col, Select, Radio } from "antd";
import { useMutation, useQueryClient } from "react-query";
import useAxiosInstance from "../../../lib/useAxiosInstance";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import ErrorMessage from "../../../components/Forms/ErrorMessage";
import GmsContext from "../../../context/gmsContext";

const TopicNameForm = ({ isOpen, isAddMode }) => {
  const gmsContext = useContext(GmsContext);
  const axiosInstance = useAxiosInstance();
  const queryClient = useQueryClient();
  const [subCategoryList, setSubCategoryList] = useState([]);

  const FormSchema = Yup.object().shape({
    parentId: Yup.string().trim().required("Sub Category is required"),
    topicName: Yup.string().trim().required("Topic Name is required").min(3),
    topicDescription: Yup.string().trim().required("Description is required").min(10)
  });

  const formik = useFormik({
    initialValues: {
      parentId: "",
      topicName: "",
      topicDescription: "",
      type: isAddMode ? '' : gmsContext.editData.type || '',
    },
    enableReinitialize: true,
    validationSchema: FormSchema,
    onSubmit: (values) => {
      handleCreate.mutate({
        parentId: values.parentId,
        topics: [
          {
            topicName: values.topicName,
            topicDescription: values.topicDescription
          }
        ],
        type : values.type,
      });
    }
  });

  const handleCreate = useMutation(
    (formData) => axiosInstance.post("api/category", formData).then(res => res.data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("topics");
        toast.success("Topic created successfully");
        closeModal();
      },
      onError: () => {
        toast.error("Error creating topic");
        closeModal();
      }
    }
  );

  const closeModal = () => {
    gmsContext.updateOpenModal(false);
    gmsContext.updateAddMode(true);
    formik.resetForm();
  };

//   const fetchSubCategories = async () => {
//     const res = await axiosInstance.get("api/category/sub");
//     // console.log("res",res)
//     setSubCategoryList(res.data.data);
//   };
    const fetchSubCategories = async () => {
        try {
        let subCategoryList = [];
        let currentPage = 1;

        while (true) {
            const response = await axiosInstance.get(
            `api/category/sub?page=${currentPage}`
            );
            // const response = await axiosInstance.get(
            // `api/category/sub?page=${currentPage}&type=${formik.values.type}`
            // );
            const categoryData = response.data.data;
            subCategoryList = [...subCategoryList, ...categoryData];

            if (currentPage >= response.data.totalpages) {
            break;
            }

            currentPage++;
        }

        const uniqueSubCategories = [
            ...new Map(subCategoryList.map(item => [item.name.toLowerCase(), item])).values()
        ];
        uniqueSubCategories.sort((a, b) => 
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );

        setSubCategoryList(uniqueSubCategories);
        } catch (error) {
        toast.error("An error occurred while fetching category data.");
        }
    };

//     const fetchSubCategories = async () => {
//   try {
//     let subCategoryList = [];
//     let currentPage = 1;
//     const seenNames = new Set();

//     while (true) {
//       const response = await axiosInstance.get(`api/category/sub?page=${currentPage}`);
//       const categoryData = response.data.data;
//         console.log("categoryData",categoryData)
//       // Filter out subcategories with duplicate names
//       const uniqueData = categoryData.filter(item => {
//         const nameLower = item.name.trim().toLowerCase();
//         if (!seenNames.has(item.name)) {
//           seenNames.add(nameLower);
//           return true;
//         }
//         return false;
//       });

//       subCategoryList = [...subCategoryList, ...uniqueData];

//       if (currentPage >= response.data.totalPages) {
//         break;
//       }

//       currentPage++;
//     }

//     setSubCategoryList(subCategoryList);
//   } catch (error) {
//     toast.error("An error occurred while fetching category data.");
//   }
// };

  useEffect(() => {
    fetchSubCategories();
  }, [formik.values.type]);

  return (
    <Modal
      className='add-user-modal'
      open={isOpen}
      onCancel={closeModal}
      width={1040}
      maskClosable={false}
      footer={[
        <button form='topic-form' type='submit' className='gms-modal-button'>
          {isAddMode ? "Add Topic" : "Save Changes"}
        </button>
      ]}
    >
      <form id='topic-form' onSubmit={formik.handleSubmit}>
        <div className='user-info-modal'>
          <div className='modal-title'><h3>Add Topic Name</h3></div>
          <div className='modal-wrapper-body'>
            <div className='modal-wrapper-content pb-7'>
              <h4>Topic Details</h4>
                {/* <Row className='add-modal-row mt-7'>
                    <Col span={8}>
                      <label htmlFor="">Type</label>
                      <Radio.Group
                        name="type"
                        onChange={formik.handleChange}
                        value={formik.values.type}
                      >
                        <Radio value="Ministry">Ministry</Radio>
                        <Radio value="Constituency">Constituency</Radio>
                      </Radio.Group>
                      <ErrorMessage
                        hasError={Boolean(formik.errors.type && formik.touched.type)}
                        message={formik.errors.type}
                      />
                    </Col>
                </Row> */}
              <Row className='add-modal-row mt-7'>
                <Col span={8}>
                  <label>Sub Category</label>
                  <Select
                    showSearch
                    size='large'
                    style={{ width: "100%" }}
                    value={formik.values.parentId}
                    onChange={(value) => formik.setFieldValue("parentId", value)}
                  >
                    <Select.Option value=''>Select Sub Category</Select.Option>
                    {subCategoryList.map(sub => (
                      <Select.Option key={sub._id} value={sub._id}>{sub.name}</Select.Option>
                    ))}
                  </Select>
                  <ErrorMessage hasError={formik.errors.parentId} message={formik.errors.parentId} />
                </Col>
              </Row>

              <Row className='add-modal-row'>
                <Col span={8} className='mr-6'>
                  <label>Topic Name</label>
                  <Input
                    name='topicName'
                    value={formik.values.topicName}
                    onChange={formik.handleChange}
                    placeholder='Enter Topic Name'
                  />
                  <ErrorMessage hasError={formik.errors.topicName} message={formik.errors.topicName} />
                </Col>

                <Col span={8}>
                  <label>Description</label>
                  <Input
                    name='topicDescription'
                    value={formik.values.topicDescription}
                    onChange={formik.handleChange}
                    placeholder='Enter Description'
                  />
                  <ErrorMessage hasError={formik.errors.topicDescription} message={formik.errors.topicDescription} />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default TopicNameForm;
